module.exports = __webpack_public_path__ + "img/spring_trip-20160416-6.3d3e0aa5.jpg";